import AgendaEntry from './agenda-entry';
import type AppUser from './app-user';

class AgendaEntryUpsert extends AgendaEntry {
  id?: string;

  user: AppUser | undefined;

  alternativeTargetEmail?: string;

  isDeleted = false;
}

export default AgendaEntryUpsert;
